import { render, staticRenderFns } from "./PkRouteConfigInfoEdit.vue?vue&type=template&id=6792c420&"
import script from "./PkRouteConfigInfoEdit.vue?vue&type=script&lang=js&"
export * from "./PkRouteConfigInfoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports